// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32DKo","right":"styles_right__1eFHL"};